import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  PersistenceService,
  Keys
} from '../../core/services/persistence.service';
import * as fromAuth from '../../store';
import { Store, select } from '@ngrx/store';
import { Role } from '../../shared/models/role';
import { finalize } from 'rxjs/operators';
import { LoaderService } from 'src/app/core/services/loader.service';

/**
 * Permite enviar el JWT como cabecera en cada peticion a los microservicios
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  role: Role;

  constructor(
    private persistence: PersistenceService,
    private loaderService: LoaderService,
    private store: Store<fromAuth.AuthState>
  ) {
    this.store
      .pipe(select(fromAuth.selectSessionCurrentrole))
      .subscribe(role => (this.role = role));
  }

  /**
   * Intercepta cada request, lo clona y retorna un nuevo request con la cabecera de autenticación
   * @param req request
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loaderService.show();
    const idToken = this.persistence.getValue(Keys.accessToken);
    if (idToken) {
      const rol = (this.role && this.role.code) || '';
      const cloned = req.clone({
        headers: new HttpHeaders({
          Authorization: idToken,
          Role: rol
        })
      });
      return next
        .handle(cloned)
        .pipe(finalize(() => this.loaderService.hide()));
    } else {
      return next.handle(req).pipe(finalize(() => this.loaderService.hide()));
    }
  }
}
